// JS dependency
var aos = require('aos');
var helper = require('./02-helper');

function financementUpdate() {
    // Passer en submit form si cela devient trop compliqué ?
    var assurances = [];
    $('#financement-types select').each(function () {
        $(this).val().forEach(function (value) {
            assurances.push(value);
        })
    });

    $.ajax({
        url: $('#financement-parametres').data('url'),
        data: {
            duree: $('#financement-duree').val(),
            apport: $('#financement-apport').val(),
            km: $('#financement-km').val(),
            type: $('input[name=financement_id]:checked').val(),
            assurances: assurances,
        }
    }).done(function (data) {
        $('#financement-types').html(data.types).find('select').selectpicker('refresh');
        $('#financement-prix').html(data.prix);
        $('#financement-types select, #financement-types input').on('change', function () {
            financementUpdate();
        });
        helper.height_equal();
    });
}

var scrollTimer = null;
$('#financement-parametres input').on('change', function () {
    // Permet d'éviter d'avoir trop de requete
    if (scrollTimer) {
        clearTimeout(scrollTimer);
    }
    scrollTimer = setTimeout(financementUpdate, 300);
}).first().trigger('change');



function f_formVehiculeContact() {
    $('#vehicule-contact-type input').change(function () {
        $('.type-element').hide();
        $('.type-' + $(this).val()).show();
    });
    $('#vehicule-contact-type input:checked, #vehicule-contact-type input[type=hidden]').trigger('change');
}
f_formVehiculeContact();

export { f_formVehiculeContact };


